<template>
	<div v-if="isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin">
		<BaseHeader :title="$t('additional_services_net').toString()"></BaseHeader>
		<div class="main">
			<div class="grid md:grid-cols-2 gap-4" v-if="!isLoading">
				<div v-for="variable in variables" :key="variable.id">
					<CompanyVariable
						:variable="variable"
						@input="editValue = true"
						:required="true"
						label-class="md:min-h-12 lg:min-h-12 xxl:min-h-full"
						:ref="'companyVariable' + variable.key"
					/>
				</div>

				<div class="" v-if="variableCustom">
					<div class="flex w-full font-bold mb-2 md:min-h-12 xxl:min-h-6" style="color: #495057">
						{{ $t('customizable_input_field') }}
					</div>
					<div class="flex flex-row gap-4">
						<BaseInput v-model="variableCustom.label" @input="$emit('input')" ref="text" class="w-2/3" :required="false" />
						<BaseInputNumber v-model="variableCustom.value" ref="number" class="w-1/3" :precision="2" :required="false" />
					</div>
				</div>
			</div>
			<LoadingSpinner v-else />

			<Footer class="mx-8 justify-end" :is-back-button="false">
				<template #continueButton>
					<SaveButton @click="save" class="w-16 btn-blue">
						{{ $t('general.save') }}
					</SaveButton>
				</template>
			</Footer>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import BaseHeader from '@/components/navigation/BaseHeader';
import CompanyVariable from '@/views/usermanagment/CompanyVariable';
import Validate from '@/mixins/Validate';
import Footer from '@/components/damagecases/Footer.vue';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import BaseInputNumber from '@/components/forms/inputs/BaseInputNumber.vue';
import CompanyVariablesRepository from '@/api/repositories/CompanyVariablesRepository';

export default {
	name: 'CompanyVariables',
	components: { BaseInputNumber, BaseInput, Forbidden, CompanyVariable, BaseHeader, LoadingSpinner, Footer, SaveButton },
	mixins: [Validate, Authentication],
	data() {
		return {
			variables: {},
			editValue: false,
			isLoading: false,
			variableCustom: null,
		};
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6 && this.isAuthenticatedUserInGroupAdmin) {
			this.isLoading = true;
			this.fetchCompanyVariables();
		}
	},
	methods: {
		fetchCompanyVariables() {
			new CompanyVariablesRepository()
				.getAll()
				.then(response => {
					this.variables = response.data.data.filter(variable => !variable.key.includes('custom_field'));
					if (!response.data.data.find(variable => variable.key.includes('custom_field'))) {
						this.variableCustom = { id: null, key: 'custom_field', label: '', value: null, type: 'number' };
					} else {
						this.variableCustom = response.data.data.find(variable => variable.key.includes('custom_field'));
					}

					this.isLoading = false;
				})
				.catch(error => {
					this.$store.dispatch('reportLogs');
					this.$swal(this.$t('error').toString(), this.$t('no_values_found').toString(), 'error');
					this.isLoading = false;
				});
		},
		save() {
			if (!this.validate()) {
				this.$swal(this.$t('general.error').toString(), this.$t('please_check_input').toString(), 'error');
				return false;
			}
			if (!this.variableCustom.value || isNaN(this.variableCustom.value)) {
				if (this.variableCustom.label) {
					return this.$swal(this.$t('general.error').toString(), this.$t('custom_field_error').toString(), 'error');
				} else {
					this.variableCustom.value = null;
				}
			} else if (!this.variableCustom.label) {
				return this.$swal(this.$t('general.error').toString(), this.$t('custom_field_label_error').toString(), 'error');
			}
			if (this.variableCustom.label === '0') {
				this.variableCustom.value = null;
				this.variableCustom.label = '';
			}

			this.isLoading = true;

			this.variables.push(this.variableCustom);

			new CompanyVariablesRepository()
				.saveBatch(this.variables)
				.then(response => {
					this.$store.commit('setConfirmLeaving', false);
					this.$swal(this.$t('general.success').toString(), this.$t('values_saved').toString(), 'success');
					this.fetchCompanyVariables();
				})
				.catch(error => {
					this.isLoading = false;
					this.$swal(this.$t('general.error').toString(), this.$t('values_save_error').toString(), 'error');
				});
		},
	},
	watch: {
		editValue: function(val, oldVal) {
			if (oldVal === false && val === true) {
				this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
			}
		},
	},
};
</script>
